import { render, staticRenderFns } from "./ReadOnlyAlertModalSection.vue?vue&type=template&id=6ff629c7"
import script from "./ReadOnlyAlertModalSection.vue?vue&type=script&lang=ts"
export * from "./ReadOnlyAlertModalSection.vue?vue&type=script&lang=ts"
import style0 from "./ReadOnlyAlertModalSection.vue?vue&type=style&index=0&id=6ff629c7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports